import { useQuery } from '@tanstack/react-query'
import { SPEND_CATEGORY_GROUP_TRANSLATIONS } from 'api/react-query/keys'
import { getCategoryGroupTranslations } from 'SpendControl/endpoints/spend-control'

export const useGetCategoryGroupTranslations = ({ categoryGroupId }: { categoryGroupId: string | undefined }) =>
  useQuery({
    queryKey: [SPEND_CATEGORY_GROUP_TRANSLATIONS, categoryGroupId],
    queryFn: () => getCategoryGroupTranslations(categoryGroupId as string),
    enabled: Boolean(categoryGroupId),
  })
